var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { COLORS } from '../../../constants/colors';
export const CashbackAlt5 = (_a) => {
    var { stroke, fill } = _a, rest = __rest(_a, ["stroke", "fill"]);
    return (_jsx("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: _jsx("path", { d: "M14.5638 8C13.9456 7.68046 13.2439 7.5 12.5 7.5C10.0145 7.5 8 9.5145 8 12C8 14.4855 10.0145 16.5 12.5 16.5C13.2439 16.5 13.9456 16.3195 14.5638 16M7 10.75H12.5M7 13.25H11.5M21.2892 14C21.4273 13.3552 21.5 12.6861 21.5 12C21.5 6.75283 17.2472 2.5 12 2.5C6.75283 2.5 2.5 6.75283 2.5 12C2.5 17.2472 6.75283 21.5 12 21.5C12.6861 21.5 13.3552 21.4273 14 21.2892M19 18L17 20M17 20L19 22M17 20C21 20 22 20 22 17", stroke: stroke !== null && stroke !== void 0 ? stroke : COLORS.PURPLE[900], strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
